import { useEffect } from "react";
import { api } from "@/lib/api";

const DEFAULTS = { bg: "#EDE5D2", ink: "#1F3D2A", accent: "#C77E3C", accent_deep: "#A05F26" };
const STYLE_ID = "jubasmash-theme-override";

export const applyTheme = (t) => {
  const theme = { ...DEFAULTS, ...(t || {}) };
  const css = `
    body, html { background-color: ${theme.bg} !important; }
    .bg-\\[\\#EDE5D2\\] { background-color: ${theme.bg} !important; }
    .bg-\\[\\#1F3D2A\\] { background-color: ${theme.ink} !important; }
    .bg-\\[\\#C77E3C\\] { background-color: ${theme.accent} !important; }
    .text-\\[\\#1F3D2A\\] { color: ${theme.ink} !important; }
    .text-\\[\\#C77E3C\\] { color: ${theme.accent} !important; }
    .border-\\[\\#1F3D2A\\] { border-color: ${theme.ink} !important; }
    .border-\\[\\#C77E3C\\] { border-color: ${theme.accent} !important; }
    .hover\\:bg-\\[\\#1F3D2A\\]:hover { background-color: ${theme.ink} !important; }
    .hover\\:bg-\\[\\#C77E3C\\]:hover { background-color: ${theme.accent} !important; }
    .hover\\:text-\\[\\#C77E3C\\]:hover { color: ${theme.accent} !important; }
    .hover\\:text-\\[\\#1F3D2A\\]:hover { color: ${theme.ink} !important; }
    .brut-shadow { box-shadow: 6px 6px 0 0 ${theme.ink} !important; }
    .brut-shadow-sm { box-shadow: 3px 3px 0 0 ${theme.ink} !important; }
    .brut-shadow-accent { box-shadow: 6px 6px 0 0 ${theme.accent} !important; }
    .btn-primary { background-color: ${theme.accent} !important; border-color: ${theme.ink} !important; }
    .btn-primary:hover { background-color: ${theme.ink} !important; box-shadow: 4px 4px 0 0 ${theme.accent} !important; }
    .btn-ghost { background-color: ${theme.bg} !important; color: ${theme.ink} !important; border-color: ${theme.ink} !important; }
    .btn-ghost:hover { background-color: ${theme.ink} !important; color: #fff !important; }
    ::selection { background: ${theme.accent}; color: #fff; }
  `;
  let el = document.getElementById(STYLE_ID);
  if (!el) {
    el = document.createElement("style");
    el.id = STYLE_ID;
    document.head.appendChild(el);
  }
  el.textContent = css;
};

export default function ThemeLoader() {
  useEffect(() => {
    api.get("/settings/theme").then(({ data }) => applyTheme(data)).catch(() => applyTheme(DEFAULTS));
  }, []);
  return null;
}
